'use client'

import {
  createToaster,
  Portal,
  Spinner,
  Stack,
  Toast,
  Toaster as ChakraToaster,
} from '@chakra-ui/react'

import {
  AlertCheckIcon,
  AlertErrorIcon,
  AlertInfoIcon,
  AlertWarnIcon,
} from '../icon'

export const toaster = createToaster({
  placement: 'top',
  pauseOnPageIdle: true,
})

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {toast => {
          let statusIcon: React.ReactNode = null
          const status = toast.type === undefined ? 'info' : toast.type
          switch (status) {
            case 'success':
              statusIcon = <AlertCheckIcon size="lg" />
              break
            case 'info':
              statusIcon = <AlertInfoIcon size="lg" />
              break
            case 'warning':
              statusIcon = <AlertWarnIcon size="lg" />
              break
            case 'error':
              statusIcon = <AlertErrorIcon size="lg" />
              break
            default:
              break
          }
          return (
            <Toast.Root
              width={{ md: 'sm' }}
              css={{
                '&[data-type=success]': {
                  bg: 'green.500',
                  color: 'green.contrast',
                  '--toast-trigger-bg': '{white/10}',
                  '--toast-border-color': '{white/40}',
                },
                '&[data-type=info]': {
                  bg: 'blue.500',
                  color: 'blue.contrast',
                  '--toast-trigger-bg': '{white/10}',
                  '--toast-border-color': '{white/40}',
                },
                '&[data-type=warning]': {
                  bg: 'orange.500',
                  color: 'orange.contrast',
                  '--toast-trigger-bg': '{white/10}',
                  '--toast-border-color': '{white/40}',
                },
                '&[data-type=error]': {
                  bg: 'red.500',
                  color: 'red.contrast',
                  '--toast-trigger-bg': '{white/10}',
                  '--toast-border-color': '{white/40}',
                },
              }}
            >
              {toast.type === 'loading' ? (
                <Spinner size="sm" color="blue.solid" />
              ) : (
                statusIcon
              )}
              <Stack gap="1" flex="1" maxWidth="100%">
                {toast.title && (
                  <Toast.Title fontSize="md" fontWeight="bold">
                    {toast.title}
                  </Toast.Title>
                )}
                {toast.description && (
                  <Toast.Description fontSize="md" opacity={1}>
                    {toast.description}
                  </Toast.Description>
                )}
              </Stack>
              {toast.action && (
                <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
              )}
              {toast.meta?.closable && <Toast.CloseTrigger />}
            </Toast.Root>
          )
        }}
      </ChakraToaster>
    </Portal>
  )
}
